import type { OoFormRouteContext } from '../types';
import { OoAffordabilityCheck } from './OoAffordabilityCheck';

interface CaseAffordabilityPageProps {
  routeContext: OoFormRouteContext;
}

export function CaseAffordabilityPage({ routeContext }: CaseAffordabilityPageProps) {
  return <OoAffordabilityCheck routeContext={routeContext} />;
}
